export default __webpack_public_path__ + "static/media/cachorro@2x.3225078f.jpg";